module.exports = __webpack_public_path__ + "img/curtain.86ce92e2.png";